import { PRESS_MENTIONS } from "../data/pressMentions";
import ScrollReveal from "./ScrollReveal";

/** Renders nothing until PRESS_MENTIONS has real entries — no placeholder strip. */
export default function PressLogoStrip() {
  if (PRESS_MENTIONS.length === 0) return null;

  return (
    <section className="border-y border-ocean-900/5 bg-foam-100 py-10 dark:border-white/10 dark:bg-ocean-900">
      <div className="mx-auto max-w-6xl px-6">
        <ScrollReveal className="text-center text-xs font-semibold uppercase tracking-widest text-ocean-800/50 dark:text-foam-100/50">
          As Featured In
        </ScrollReveal>
        <div className="mt-6 flex gap-10 overflow-x-auto px-2 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {PRESS_MENTIONS.map((mention) => (
            <a
              key={mention.outlet}
              href={mention.articleUrl}
              target="_blank"
              rel="noreferrer"
              className="flex shrink-0 items-center opacity-60 grayscale transition-opacity hover:opacity-100 hover:grayscale-0"
            >
              <img
                src={mention.logoUrl}
                alt={mention.outlet}
                loading="lazy"
                className="h-7 w-auto object-contain"
              />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
